import { ReactNode } from "react";

import Box from "@mui/material/Box";

type StatusIconContainerProps = {
  children: ReactNode;
  color?: string;
};
export default function StatusIconContainer({
  color,
  children
}: StatusIconContainerProps) {
  return (
    <Box
      boxSizing="border-box"
      display="flex"
      alignItems="center"
      sx={{
        "& svg": {
          height: 18,
          width: 18
        },
        color
      }}
    >
      {children}
    </Box>
  );
}
